import ShortStory from './ShortStory.vue';
import ShortStoryList from './ShortStorylist.vue';
export default {
  ShortStory,
  ShortStoryList,
};
